export const FAVORITE_TEMPLATE = 'GalleryPB/*/FavoriteTemplate';
export const INIT_FAVORITES = 'GalleryPB/*/InitFavorites';
